import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import "./style.css";

import Navbar from "../../../components/Landing_page_Navbar/index";
import Hero from "./components/Hero";
import WhatIs from "./components/WhatIs";
import WhyUse from "./components/WhyUse";
import Sectors from "./components/Sectors";
import ConnectsNeeds from "./components/ConnectsNeeds";
import OneBusinessRoles from "./components/OneBusinessRoles";
import ConnectionModel from "./components/ConnectionModel";
import BusinessJourney from "./components/BusinessJourney";
import MarketingAgent from "./components/MarketingAgent";
import EcosystemMap from "./components/EcosystemMap";
import ConsumerToOpportunity from "./components/ConsumerToOpportunity";
import Footer from "./components/Footer";
import MotionSection from "./components/MotionSection";
import { MotionConfig } from "framer-motion";

export default function Home() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title =
      "SELECTEZI | The Global Business Resource & Opportunity Ecosystem";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  useEffect(() => {
    const updateBackToTopVisibility = () => {
      setShowBackToTop(window.scrollY > 320);
    };

    updateBackToTopVisibility();
    window.addEventListener("scroll", updateBackToTopVisibility, {
      passive: true,
    });
    return () =>
      window.removeEventListener("scroll", updateBackToTopVisibility);
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="selectezi-app">
        <Navbar />
        <MotionSection>
          <Hero />
        </MotionSection>
        <MotionSection>
          <WhatIs />
        </MotionSection>
        <MotionSection>
          <WhyUse />
        </MotionSection>
        <MotionSection>
          <Sectors />
        </MotionSection>
        <MotionSection>
          <ConnectsNeeds />
        </MotionSection>
        <MotionSection>
          <OneBusinessRoles />
        </MotionSection>
        <MotionSection>
          <ConnectionModel />
        </MotionSection>
        <MotionSection>
          <BusinessJourney />
        </MotionSection>
        <MotionSection>
          <MarketingAgent />
        </MotionSection>
        <MotionSection>
          <EcosystemMap />
        </MotionSection>
        <MotionSection>
          <ConsumerToOpportunity />
        </MotionSection>
        <MotionSection>
          <Footer />
        </MotionSection>
        <button
          type="button"
          className={`landing-back-to-top${showBackToTop ? " landing-back-to-top--visible" : ""}`}
          aria-label="Back to top"
          title="Back to top"
          tabIndex={showBackToTop ? 0 : -1}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <ArrowUp size={21} strokeWidth={2.2} aria-hidden="true" />
        </button>
      </div>
    </MotionConfig>
  );
}
